import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useT } from "@/lib/LanguageContext";
import { PHOTOS } from "@/lib/images";

export default function FinalCta() {
  const { t } = useT();
  const c = t.finalCta;

  return (
    <section
      data-testid="final-cta-section"
      className="relative py-24 md:py-36 bg-[#4B2F4F] text-[#F7F3F7] vk-grain overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="col-span-12 md:col-span-5 relative"
          >
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={PHOTOS.finalCtaImage}
                alt=""
                aria-hidden="true"
                className="w-full h-full object-cover"
                data-testid="final-cta-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#4B2F4F]/40 via-transparent to-transparent" />
            </div>
            <div className="hidden md:block absolute -top-6 -right-6 w-24 h-24 border border-[#F7F3F7]/30" />
          </motion.div>

          <div className="col-span-12 md:col-span-7 md:pl-8">
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              data-testid="final-cta-headline"
              className="font-serif font-light text-[clamp(2.4rem,5.4vw,5rem)] leading-[0.98] tracking-tight"
            >
              {c.headline.l1}
              <br />
              {c.headline.l2}
              <br />
              <span className="italic">{c.headline.l3}</span>
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.15 }}
              className="mt-8 text-lg md:text-xl text-[#F7F3F7]/85 max-w-xl leading-relaxed"
            >
              {c.body}
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.3 }}
              className="mt-12"
            >
              <a
                href="#contacto"
                data-testid="final-cta-button"
                className="group inline-flex items-center gap-3 bg-[#E0B25B] text-[#F7F3F7] px-10 py-5 text-[12px] uppercase tracking-[0.24em] font-medium hover:bg-[#F7F3F7] hover:text-[#4B2F4F] transition-colors duration-300"
              >
                {c.cta}
                <ArrowRight
                  size={16}
                  strokeWidth={1.4}
                  className="group-hover:translate-x-1 transition-transform duration-300"
                />
              </a>
              <p className="mt-6 text-[12px] tracking-[0.04em] text-[#F7F3F7]/65">
                {c.languages}
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
